__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['travel-personalized-marketing-articles'].baseUrl;
import ModuleContainer from './components/PersonalizedMarketingArticles';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "6.x"
  });
}
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    requiredExternals: {
      '@americanexpress/one-app-module-wrapper': '^3.4.4',
      '@americanexpress/travel-selectors': '^5.0.0',
      '@americanexpress/one-experiments': '^2.1.3',
      'react-intl': '^6.5.5'
    }
  });
}